import { render, staticRenderFns } from "./TranslationsStats.vue?vue&type=template&id=97c5267e&"
import script from "./TranslationsStats.vue?vue&type=script&lang=js&"
export * from "./TranslationsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports